import { Locale } from '@cars4ever/public-ui';

export const API_URL = import.meta.env.PRICE_LIST_PUBLIC_API_URL || '';
export const APP_INSIGHTS_INSTRUMENTATION_KEY = import.meta.env.PRICE_LIST_PUBLIC_APP_INSIGHTS_INSTRUMENTATION_KEY || '';
export const GTM_ID = import.meta.env.PRICE_LIST_PUBLIC_GTM_ID || '';
export const CLOUD_NAME = import.meta.env.PRICE_LIST_PUBLIC_CLOUD_NAME || '';
export const LOCALE = import.meta.env.PRICE_LIST_PUBLIC_LOCALE as Locale;
export const WIDGET_URL = import.meta.env.PRICE_LIST_PUBLIC_WIDGET_URL || '';
export const RETAIL_WISMO_URL = import.meta.env.PRICE_LIST_PUBLIC_RETAIL_WISMO_URL || '';
export const BRAND_CONFIG_URL = import.meta.env.PRICE_LIST_PUBLIC_FACE_BRAND_CONFIG_URL || '';

